import React from "react";
import IntegrationStatusBadge from "./IntegrationStatusBadge";

const NAVY = "#0A316E";

// Durum → üst şerit + hafif arka plan tonu + sağ üst nokta rengi
const ACCENT = {
    connected: { bar: "linear-gradient(90deg, #2f9e44, #51cf66)", bg: "linear-gradient(180deg, rgba(47,158,68,.06), rgba(47,158,68,0))", dot: "#2f9e44" },
    pending: { bar: "linear-gradient(90deg, #E8590C, #ffd43b)", bg: "linear-gradient(180deg, rgba(232,89,12,.07), rgba(232,89,12,0))", dot: "#E8590C" },
    soon: { bar: "linear-gradient(90deg, #E56A22, #ffd43b)", bg: "#fff", dot: "#c9ced8" },
    // Paket kapsamı dışında: sağlayıcı çalışır durumda ama firmanın paketi içermiyor.
    locked: { bar: "linear-gradient(90deg, #adb5bd, #ced4da)", bg: "#fbfcfd", dot: "#adb5bd" },
    passive: { bar: "transparent", bg: "#fff", dot: "#c9ced8" },
};

// Durum → aksiyon buton metni/stili
const ACTION = {
    connected: { label: "Yapılandır", icon: "bx-cog", variant: "navy" },
    passive: { label: "Bağla", icon: "bx-link", variant: "outline" },
    pending: { label: "Beklemede", icon: "bx-time", variant: "disabled" },
    soon: { label: "Yakında", icon: "bx-time", variant: "disabled" },
    locked: { label: "Paket Gerekli", icon: "bx-lock-alt", variant: "disabled" },
};

const LogoTile = ({ integration }) => (
    <div
        className="d-flex align-items-center justify-content-center bg-white shadow-sm"
        style={{ width: 64, height: 64, borderRadius: 16, overflow: "hidden", flexShrink: 0 }}
    >
        {integration.logo ? (
            <img
                src={integration.logo}
                alt={integration.name}
                style={{ maxWidth: "82%", maxHeight: "82%", objectFit: "contain" }}
            />
        ) : (
            <i
                className={`bx ${integration.icon || "bx-plug"}`}
                style={{ fontSize: 32, color: integration.accent || NAVY }}
            />
        )}
    </div>
);

export default function IntegrationCard({ integration, status = "passive", onAction }) {
    const accent = ACCENT[status] || ACCENT.passive;
    const action = ACTION[status] || ACTION.passive;
    const disabled = action.variant === "disabled";

    const actionStyle =
        action.variant === "navy"
            ? { backgroundColor: NAVY, borderColor: NAVY, color: "#fff" }
            : action.variant === "outline"
            ? { backgroundColor: "#fff", borderColor: "#dfe3ea", color: NAVY }
            : { backgroundColor: "#f4f6f9", borderColor: "#e7eaf0", color: "#9aa2b1" };

    return (
        <div
            className="h-100 d-flex flex-column border-0 shadow-sm"
            style={{ borderRadius: 16, overflow: "hidden", background: accent.bg }}
        >
            {/* Üst durum şeridi */}
            <div style={{ height: 4, background: accent.bar }} />

            <div className="p-3 d-flex flex-column flex-grow-1">
                <div className="d-flex justify-content-between align-items-start">
                    {/* Logo + isim yan yana: logo alanı büyütüldü, isim logonun yanında daha büyük */}
                    <div className="d-flex align-items-center gap-3" style={{ minWidth: 0 }}>
                        <LogoTile integration={integration} />
                        <h6
                            className="fw-bold mb-0 text-truncate"
                            style={{ color: "#1f2937", fontSize: 17, lineHeight: 1.25 }}
                        >
                            {integration.name}
                        </h6>
                    </div>
                    <span
                        className="rounded-circle"
                        style={{ width: 10, height: 10, backgroundColor: accent.dot, marginTop: 4, flexShrink: 0 }}
                    />
                </div>

                <p className="text-muted mt-3 mb-3" style={{ fontSize: 13.5, lineHeight: 1.35 }}>
                    {integration.description}
                </p>

                <div className="d-flex align-items-center justify-content-between mt-auto pt-1 gap-2">
                    <IntegrationStatusBadge status={status} />
                    <button
                        type="button"
                        className="btn btn-sm d-inline-flex align-items-center gap-1 fw-semibold"
                        style={{ borderRadius: 999, padding: ".4rem .9rem", ...actionStyle }}
                        disabled={disabled}
                        onClick={disabled ? undefined : onAction}
                    >
                        <i className={`bx ${action.icon}`} />
                        {action.label}
                    </button>
                </div>
            </div>
        </div>
    );
}
